<template lang="pug">
  div.CoverSectionContent
    CoverSection.SampleCover#SampleCover
      .SampleCover_cache(ref="backgroundcache")

      .SampleCover_imgContainer
        transition(:name="transitionType" mode="out-in" appear)
          ZoomableImg(:isSample="isSample", :src="item.allImages" :key="item.id" :actualSlide="actualSlide" :isThinBlade="isThinBlade" @getref="setref").SampleCover_image
      .SampleCover_info
        transition(:name="transitionType" mode="out-in" appear)
          .SampleCover_info_container(:key="item.id")
            p.SampleCover_name {{ item.name }}
            ButtonSimple(:to="item.drawer.collection.url") {{ item.drawer.collection.title }}
            ButtonSimple(:to="item.drawer.url") {{ $t('collection.drawer') }} {{ item.drawer.name }}

      //- Ne pas supprimer
      //- slot(name="sample_features")
      //- transition(name="fade" mode="out-in" appear)
      //-   SampleDetails(:items="item.details" @toggleMoreInfos="toggleMoreInfos" :key="item.id")

      .SampleCover_footer
        div.SampleCover-listIcons(v-if="typeof item._included[0].attributes.iframe !== 'undefined' || item._data.attributes.availability_thin_section_photos === true")
          ul
            li(v-if="typeof item._included[0].attributes.iframe !== 'undefined'")
              button(:data-src="item._included[0].attributes.iframe.url").popin
                <svg aria-labelledby="icon3d" role="img" fill="#ffefce" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 38" width="49" height="38"><path d="M2.988281 2.347656v32.304688h42.023438V2.347656ZM43.5625 33.191406H4.4375V3.808594h39.125Zm0 0"/><path d="M19.945312 22.308594c-.234374.34375-.558593.613281-.976562.808594-.417969.191406-.902344.289062-1.457031.289062-.839844 0-1.523438-.199219-2.054688-.59375-.53125-.390625-.828125-.898438-.890625-1.523438l-.011718-.085937h-1.511719l.007812.105469c.058594.667968.277344 1.265625.652344 1.789062.375.519532.886719.933594 1.535156 1.234375.648438.296875 1.40625.449219 2.273438.449219.84375 0 1.597656-.160156 2.257812-.480469.65625-.320312 1.175781-.757812 1.554688-1.316406.378906-.558594.570312-1.191406.570312-1.894531v-.015625c0-.90625-.285156-1.632813-.851562-2.179688-.570313-.550781-1.316407-.863281-2.234375-.941406v-.035156c.523437-.109375.988281-.300781 1.390625-.570313.402343-.269531.71875-.609375.945312-1.011718.226563-.40625.339844-.871094.339844-1.394532v-.015625c0-.648437-.164063-1.214843-.492187-1.703125-.332032-.492187-.796876-.875-1.394532-1.15625-.597656-.277344-1.296875-.417968-2.101562-.417968-.789063 0-1.484375.144531-2.085938.429687-.601562.289063-1.085937.691406-1.453125 1.207031-.363281.519532-.582031 1.125-.652343 1.816406l-.007813.085938h1.511719l.011718-.085938c.046876-.429687.1875-.800781.417969-1.109374.234375-.3125.542969-.550782.933594-.71875.386719-.167969.828125-.25 1.324219-.25.511718 0 .949218.082031 1.308594.246093.355468.164063.628906.402344.816406.714844.1875.308594.28125.6875.28125 1.132813v.019531c0 .421875-.109375.800781-.324219 1.132812-.214844.332031-.515625.59375-.898437.785157-.390626.1875-.832032.28125-1.332032.28125h-1.515625v1.335937h1.582031c.886719 0 1.589844.210937 2.105469.632813.515625.417968.773438 1.019531.773438 1.800781v.015625c0 .449218-.117188.84375-.347657 1.1875ZM32.050781 23.8125c.886719-.5 1.566407-1.226562 2.039063-2.179688.472656-.949218.707031-2.089843.707031-3.425781v-.015625c0-1.332031-.238281-2.46875-.710937-3.414062-.476563-.941406-1.15625-1.664063-2.042969-2.167969-.886719-.5-1.957031-.753906-3.203125-.753906h-4.242188v12.710937h4.242188c1.253906 0 2.324218-.25 3.210937-.753906Zm-5.878906-.671875v-9.855469h2.566406c.953125 0 1.765625.1875 2.425781.566406.660157.378907 1.164063.9375 1.507813 1.671876.34375.734374.519531 1.628906.519531 2.6875v.015624c0 1.050782-.171875 1.941407-.519531 2.671876-.34375.730468-.847656 1.289062-1.507813 1.671874-.664062.378907-1.472656.570313-2.425781.570313Zm0 0"/></svg>
                span.popin-label#icon3d {{ $t('icon.3d') }}
        //- li(v-if="item._data.attributes.availability_thin_section_photos === true")
        //-   <svg aria-labelledby="thin_blade" role="img" fill="#ffefce" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 37" width="48" height="37"><path d="M2.988281 2.347656v32.304688h42.023438V2.347656Zm35.257813 30.84375-7.34375-7.398437c.371094-.34375.71875-.714844 1.035156-1.105469l8.445312 8.503906ZM24 27.042969c-4.832031 0-8.765625-3.960938-8.765625-8.832031 0-4.867188 3.933594-8.828126 8.765625-8.828126 4.835938 0 8.769531 3.960938 8.769531 8.828126 0 4.871093-3.933593 8.832031-8.769531 8.832031Zm19.5625 6.148437h-1.128906L32.78125 23.46875c.914062-1.539062 1.4375-3.335938 1.4375-5.257812 0-5.671876-4.582031-10.289063-10.21875-10.289063-5.632812 0-10.214844 4.617187-10.214844 10.289063 0 5.675781 4.582032 10.292968 10.214844 10.292968 2.136719 0 4.117188-.664062 5.761719-1.796875l6.4375 6.484375H4.4375V3.808594h39.125Zm0 0"/><path d="M17.039062 18.210938h1.445313c0-3.0625 2.476563-5.550782 5.515625-5.550782v-1.460937c-3.839844 0-6.960938 3.148437-6.960938 7.011719Zm0 0"/></svg>
        //-   span.SampleListItem-images#thin_blade {{ $t('icon.thin_blade') }}

        //- .SampleCover_share.Cta_round
        //-   SvgInline(src="share")

        transition(name="fade" mode="out-in" appear)
          p.SampleCover_type(:key="item.id") {{ $t('sample.types.' + item.type) }}

        //- a.SampleCover_navLink.SampleCover_navLink-prev
        //-   SvgInline(src="arrow-line-left")

        a.SampleCover_navLink.SampleCover_navLink-prev(@click="clickPrev" v-if="item.allImages.length > 1")
          SvgInline.first(src="arrow-line-left")
          SvgInline.second(src="arrow-line-left")

        span(:key="item.id") {{ $t('drawer.sample') }} {{ item.number }}

        //- a.SampleCover_navLink.SampleCover_navLink-next
        //-   SvgInline(src="arrow-line-right")
        a.SampleCover_navLink.SampleCover_navLink-next(@click="clickNext" v-if="item.allImages.length > 1")
          SvgInline.first(src="arrow-line-right")
          SvgInline.second(src="arrow-line-right")

        div.SampleCover_pagination(:style=" item.allImages.length > 1 ? '' : 'display: none' ") {{ $t('image') }} {{ actualSlide + 1 }} / {{ item.allImages.length }}

    SampleDetails(:items="item.details" @toggleMoreInfos="toggleMoreInfos" :key="item.id")
</template>

<script>

import SvgInline from '@/components/SvgInline'
import ButtonSimple from '@/components/common/ButtonSimple'
import SampleDetails from '@/components/SampleDetails'
import ZoomableImg from '@/components/common/ZoomableImg'
import CoverSection from '@/components/common/CoverSection'

export default {
  props: ['item'],
  components: { SvgInline, ButtonSimple, CoverSection, ZoomableImg, SampleDetails },
  data () {
    return {
      imgRef: null,
      direction: 1,
      actualSlide: 0,
      isThinBlade: false,
      isSample: true
    }
  },
  methods: {
    setref (e) {
      this.imgRef = e
    },
    toggleMoreInfos (state) {
      this.$emit('toggleMoreInfos', state)
    },

    checkIsThinBlade() {
      const currentItem = this.item.allImages[this.actualSlide]
      this.isThinBlade = !!currentItem.thin_section_photo
    },

    clickNext (e) {
      e.preventDefault()
      if (this.actualSlide < this.item.allImages.length - 1) {
        this.actualSlide += 1
      } else {
        this.actualSlide = 0
      }
      this.checkIsThinBlade()
    },

    clickPrev (e) {
      e.preventDefault()
      if (this.actualSlide > 0) {
        this.actualSlide -= 1
      } else {
        this.actualSlide = this.item.allImages.length - 1
      }
      this.checkIsThinBlade()
    }
  },
  computed:
  {
    typeName () {
      const k = 'sample.types.' + this.item.type
      return this.$t(k)
    },
    transitionType () {
      return this.direction === 1 ? 'normal' : 'reverse'
    }
  },
  mounted () {
    this.checkIsThinBlade()
    this.$parallax.remove(this.$refs.backgroundcache)
    const popinTrigger = document.querySelector('.popin')

    if (popinTrigger) {
      const body = document.querySelector('body')
      const popinUrl = popinTrigger.getAttribute('data-src')
      popinTrigger.addEventListener('click', (trigger) => {
        // Add class to avoid the possibility of scrolling
        body.classList.add('overlay')

        // Create popin
        const popin = document.createElement('div')
        popin.classList.add('popin-content')

        // Create Close Button
        const closeBtn = document.createElement('button')
        closeBtn.classList.add('popin-close')
        closeBtn.textContent = this.$t('popin.close')
        closeBtn.addEventListener('click', (trigger) => {
          body.classList.remove('overlay')
          popin.remove()
        })

        // Close popin when escape button is pressed
        document.addEventListener('keyup', e => {
          if (e.key === 'Escape') {
            closeBtn.click()
          }
        })

        // Create iframe
        const iframe = document.createElement('iframe')
        iframe.setAttribute('src', popinUrl)
        iframe.setAttribute('allowfullscreen', '')
        iframe.setAttribute('frameborder', 0)
        iframe.setAttribute('scrolling', 'auto')

        popin.appendChild(closeBtn)
        popin.appendChild(iframe)
        body.appendChild(popin)
      })
    }
  },
  beforeDestroy () {
    // this.$parallax.remove(this.$refs.backgroundcache)
  }
}

</script>

<style lang="stylus">
@keyframes animOpacity {
  25% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

body.overlay
  overflow hidden

  &::before
    opacity 0
    animation-duration 1s
    animation-name animOpacity
    animation-fill-mode forwards
    position fixed
    content ''
    width 100vw
    height 100vh
    z-index 20
    top 0
    left 0
    background rgba(0, 0, 0, .75)

.popin
  cursor pointer
  background none
  border none
  padding 0

  &:hover
    transition all .6s $ease
    transform scale(0.9)
    opacity 0.7

  &-label
    clip rect(0 0 0 0)
    -webkit-clip-path inset(50%)
    clip-path inset(50%)
    height 1px
    overflow hidden
    position absolute
    white-space nowrap
    width 1px

  &-close
    font-family 'interstate'
    color white
    text-transform uppercase
    font-size 16px
    color $beige
    position absolute
    top -30px
    right 0
    padding-left 10px
    cursor pointer
    background none
    border none
    padding-right 0

    &:hover
     opacity .7

    &::before
    &:after
      content ''
      position absolute
      left 0
      height 15px
      width 1px
      background-color $beige

    &:before
     transform rotate(45deg)

    &:after
     transform: rotate(-45deg)

  &-content
    opacity 0
    animation-duration 1s
    animation-name animOpacity
    animation-fill-mode forwards
    position absolute
    width 80%
    height 0
    padding-bottom 40%
    top 50%
    right 50%
    transform translate(50%, -50%)
    z-index 21

    iframe
      position absolute
      top 0
      left 0
      width 100%
      height 100%

.CoverSectionContent
  background-color #000
  position relative

.SampleCover
  position: fixed;
  width calc(100% - 70px)
  z-index 2
  overflow hidden

  &-listIcons
    display flex
    justify-content center
    align-items center

    ul
      padding 0
      display flex

      li
        cursor default
        margin 0 5px

        svg
          width auto

        span
          margin 0

  @media $mq_s_only
    width: calc(100% - 40px);

  .normal-enter,
  .reverse-leave-to
    transform translate3d(20%, 0, 0)
    opacity 0

  .normal-leave-to,
  .reverse-enter
    transform translate3d(-20%, 0, 0)
    opacity 0

  .normal-enter-active
  .reverse-enter-active
    transition all 1.2s $ease

  .normal-leave-active
  .reverse-leave-active
    transition all 1s $ease

  &.is-sticky
    position absolute
    bottom 0
    width 100%

  &.is-disabled

    @media $mq_s_only

      .SampleCover_info, .SampleCover_footer

        opacity 0.1
        pointer-events none
        touch-action none

    @media $mq_m_only

      .SampleCover_info, .SampleCover_footer

        opacity 0.1
        pointer-events none
        touch-action none

  &_imgContainer

    z-index 9

  &_cache

    background-color $black
    top 0px
    left 0px
    height 100%
    width 100%
    z-index 100
    opacity 0
    position absolute
    pointer-events none
    touch-action none

  &_info

    position absolute
    z-index 10
    transition opacity 0.8s $ease
    top 50%
    pointer-events none
    touch-action none
    left 100px
    max-width 40vw
    transform translateY(-50%)
    text-align left

    @media $mq_m_only

      max-width unset
      left 50px

    @media $mq_s_only

      max-width unset
      position relative
      top unset
      left unset
      transform none
      text-align center

    .ButtonSimple

      margin-left 0px
      pointer-events auto
      touch-action auto
      margin-bottom 10px

      @media $mq_s_only

        display none

  &_share

    position absolute
    left 100px
    top 50%
    transform translateY(-50%)
    height 50px
    width 50px
    cursor pointer
    border 1px solid $beige
    border-radius 50%
    box-sizing border-box
    display flex
    flex-direction column

    @media $mq_m_only

      left 50px

    @media $mq_s_only

      display none

    svg

      width 22px!important
      height 17px
      margin auto

  &_name

    color #FFFFFF
    font-size 80px
    font-family 'Sectra Display'
    margin-bottom 30px
    line-height 90%

    @media $mq_m_only

      font-size 70px

    @media $mq_s_only

      font-size 20px
      margin-bottom 0px

  &_imgContainer
      position: relative
      margin-bottom 65px
      flex-grow: 1
      height 0 // debug, si pas de taille au départ, l'image agrandi le container (la taille sera défini par flexbox)
      margin-top 7.5vw

  &_image
    position: relative
    display: flex
    width auto
    height 100%
    margin 0 auto

  &_footer

    display flex
    flex-direction row
    position relative
    width 100%
    transition opacity 0.8s $ease
    box-sizing border-box
    padding 50px 50px 50px 50px
    align-items center
    color white
    z-index 10
    text-transform uppercase
    letter-spacing: 0.15em;
    display block
    margin-left auto
    margin-right auto
    text-align center

    @media $mq_l_only

      padding-right 27%

    @media $mq_m_only

      padding-left 30px
      padding-right 30px

    @media $mq_s_only

      padding 10px 20px 30px 20px

    &:hover

      span

        margin 0px 20px

        @media $mq_s_only

          margin auto 8px

        @media $mq_m

          margin auto 30px

    @media $mq_s_only
      font-size: 14px;

    span

      margin auto 15px
      transition margin 0.8s $ease
      vertical-align middle

      @media $mq_m
        margin auto 25px

      @media $mq_s_only

        margin auto 8px
        font-size 12px

    svg

      margin auto
      vertical-align middle
      width 45px

      @media $mq_m
        width 65px

  .SampleCover_type

    font-weight 800
    margin-bottom 20px
    color: $beige

  .SampleCover_navLink-prev

    cursor w-resize

    .first

      left 0px

    .second

      left 130%

  .SampleCover_navLink-next

    cursor e-resize

    .first

      right 0px

    .second

      right 130%

  &_pagination

    margin-top 10px

  &_navLink

    transition all 0.8s $ease
    overflow-x hidden
    display inline-block
    width 65px
    height 10px
    position relative

    @media $mq_s_only

      width 45px

    svg

      position absolute
      top 50%
      transition all 1s $ease
      transform translateY(-50%)

      &.first

        transition-delay 0.1s

      &.second

        transition-delay 0s

    &:hover

      opacity 0.5

      &.SampleCover_navLink

        .first

          transition-delay 0s

        .second

          transition-delay 0.1s

      &.SampleCover_navLink-prev

        .first

          left -130%

        .second

          left 0%

      &.SampleCover_navLink-next

        .first

          right -130%

        .second

          right 0%

    &.is-disabled
      opacity: 0
      pointer-events: none

</style>
